// Companion to react-legacy-default-props.js.
//
// App source compiles with the automatic JSX transform, so `<Popup />` becomes
// jsx(Popup, props) — it never reaches createElement. Patching only
// createElement therefore fixes grow-ui rendering *its own* children but not
// grow-ui components rendered from app source, which is most of them.
//
// Aliased over `react/jsx-runtime` via vite.config.mjs / vitest.config.mjs;
// `__react_jsx_runtime_actual__` points at the real entry.
// eslint-disable-next-line import/no-unresolved -- vite.config.mjs alias
import * as JsxRuntime from '__react_jsx_runtime_actual__';
import { applyLegacyDefaultProps } from './react-legacy-default-props';

const baseJsx = JsxRuntime.jsx;
const baseJsxs = JsxRuntime.jsxs;

export function jsx(type, props, key) {
  return baseJsx(type, applyLegacyDefaultProps(type, props), key);
}

export function jsxs(type, props, key) {
  return baseJsxs(type, applyLegacyDefaultProps(type, props), key);
}

export const { Fragment } = JsxRuntime;

export default { ...JsxRuntime, jsx, jsxs };
